import { takeLatest, takeEvery, all } from 'redux-saga/effects';

import API from '../../services';

import { AuthTypes } from '../actions/auth.actions';
import { AppTypes } from '../actions/app.actions';
import { ReportsTypes } from '../actions/reports.actions';
import { GoalsTypes } from '../actions/goals.actions';
import { TodoListTypes } from '../actions/todolist.actions';
import { TaskManagementTypes } from '../actions/taskmanagement.actions';
import { HumanResourcesTypes } from '../actions/humanresources.actions';
import { ChecklistTypes } from '../actions/checklist.actions';
import { ShiftsTypes } from '../actions/shifts.actions';
import { ShiftDetailsTypes } from '../actions/shift-details.actions';
import { ShiftTypes } from '../actions/shift.actions';
import { StatsTypes } from '../actions/stats.actions';
import { ShiftAdminTypes } from '../actions/shift-admin.actions';
import { StatsCompanyTypes } from '../actions/stats-company.actions';
import { CompanyTypes } from '../actions/company.actions';

import {
  loginRequest,
  registerDeviceTokenRequest,
  logoutRequest,
  forgotPasswordRequest,
  resetPasswordRequest,
  updateUserInformationRequest,
  updatePasswordRequest,
  acceptInviteRequest,
  setPasswordRequest,
  getMyCompanyRequest,
  clearRequest,
} from './auth.saga';

import {
  getBranchesRequest,
  getRolesRequest,
  getServerTimeRequest,
  setServerTimeRequest,
  getAlertsRequest,
  toggleAlertRequest,
} from './app.saga';

import {
  getMTDYTDClientUncategorizedRequest,
  getYTDClientStatsRequest,
  getMTDPastYearsClientStatsRequest,
  getDailyEmployeesShiftRequest,
  getWeeklyEmployeesShiftRequest,
} from './reports.saga';

import {
  createClientGoalForBonusRequest,
  updateClientGoalForBonusRequest,
  getMTDYTDClientRRGoalsRequest,
} from './goals.saga';

import {
  getTodoChecklistRequest,
  submitTodoChecklistRequest,
  updateChecklistCommentRequest,
  deleteChecklistCommentRequest,
  getUsersCustomCommissionsRequest,
  approveCustomCommissionRequest,
  declineCustomCommissionRequest,
} from './todolist.saga';

import {
  getAssignerTasksRequest,
  createNewTaskRequest,
  closeTaskRequest,
  readTaskRequest,
  approveCompletedRequest,
  rejectCompletedRequest,
  approveNewDeadlineRequest,
  declineNewDeadlineRequest,
  getReceiverTasksRequest,
  proposeNewDeadlineRequest,
  cancelNewDeadlineRequest,
  markAsCompletedRequest,
  acknowledgeUncompletedRequest,
} from './taskmanagement.saga';

import {
  getUsersRequest,
  employeeFileListRequest,
  uploadEmpFileRequest,
  getUsersInfractionsRequest,
  getUsersActivitiesRequest,
  getUsersTaskHistoryRequest,
  getUsersCommissionHistoryRequest,
  getUsersActivityOverviewByIdRequest,
  getUsersByBranchRequest,
  getUsersActivityPageRequest,
  getOverallUserActivityRequest,
} from './humanresources.saga';

import {
  getChecklistRequest,
  getChecklistByCategoryRequest,
  createChecklistItemRequest,
  createChecklistItemsMultipleRequest,
  editChecklistItemRequest,
  deleteChecklistItemRequest,
  submitUserNTChecklistRequest,
  fetchUserChecklistRequest,
  getUserNTChecklistRequest,
  submitStartShiftChecklistRequest,
  submitEndShiftChecklistRequest,
  getUserShiftChecklistRequest,
} from './checklist.saga';

import {
  getAllShiftsRequest,
  getUserShiftsRequest,
  getShiftRequest,
  createShiftRequest,
  updateShiftRequest,
  deleteShiftRequest,
} from './shifts.saga';

import {
  getShiftDetailsRequest,
  createTimeClockRequest,
  updateTimeClockRequest,
  deleteTimeClockRequest,
  createIndividualCommissionsRequest,
  updateIndividualCommissionsRequest,
  deleteIndividualCommissionsRequest,
  createTeamCommissionsRequest,
  updateTeamCommissionsRequest,
  deleteTeamCommissionsRequest,
  createPerVehicleCommissionsRequest,
  updatePerVehicleCommissionsRequest,
  deletePerVehicleCommissionsRequest,
} from './shift-details.saga';

import {
  getShiftStatusRequest,
  startShiftRequest,
  pauseShiftRequest,
  resumeShiftRequest,
  takeBreakRequest,
  endBreakRequest,
  endShiftRequest,
  trackLocationRequest,
  getShiftRepossessionsOverviewRequest,
  getShiftRepossessionsGoalsRequest,
  getShiftRepossessionsHitListRequest,
  getSpottedVehicleByVinRequest,
  submitSpottedVehicleRequest,
  submitCustomCommissionRequest,
  getCustomCommissionsRequest,
  updateCustomCommissionRequest,
  cancelCustomCommissionRequest,
  getShiftInfractionsRequest,
  getShiftPendingInfractionsRequest,
  submitInfractionAnswerRequest,
} from './shift.saga';

import {
  getMyActivityLevelRequest,
  getMyInfractionsRequest,
  getInfractionsDetailsRequest,
  getMySpottedVehiclesRequest,
  getMyRepossessionsRequest,
  getMyHoursWorkedRequest,
  getDayShiftsRequest,
  getDayExtraneousTimesRequest,
  getMyCommissionsRequest,
  getMyMissedOpportunitiesRequest,
} from './stats.saga';

import {
  // getActiveShiftsOverviewRequest,
  getShiftPrevPeriodOverviewRequest,
  getShiftCommissionsRequest,
  // getShiftAlertsFeedRequest,
  // getShiftAlertsPaginationFeedRequest,
  saveAllInfractionsRequest,
  saveUserInfractionAsRecordRequest,
  deleteUserInfractionRequest,
  // getShiftChecklistFeedRequest,
  markFailedChecklistAsCompletedRequest,
  getShiftHotListFeedRequest,
  updateHotListVehicleCommentRequest,
  deleteHotListVehicleCommentRequest,
  archiveManualHotListRequest,
} from './shift-admin.saga';

import {
  getActivityLevelRequest,
  getInfractionsRequest,
  getUserInfractionsRequest,
  getTotalMissedRepossessionsRequest,
  getMissedRepossessionsRequest,
  getTotalSpottedVehiclesRequest,
  getSpottedVehiclesRequest,
  getTotalRepossessionsRequest,
  getRepossessionsRequest,
  getHoursWorkedRequest,
  getTotalCommissionsRequest,
  getCommissionsRequest,
} from './stats-company.saga';

import { getCompanyDataRequest } from './company.saga';

const api = API.create();

export default function* root() {
  // console.log(ChecklistTypes.GET_CHECKLIST_REQUEST, 'yeild value');
  yield all([
    // Auth Sagas
    takeLatest(AuthTypes.LOGIN_REQUEST, loginRequest, api),
    takeLatest(AuthTypes.REGISTER_DEVICE_TOKEN_REQUEST, registerDeviceTokenRequest, api),
    takeLatest(AuthTypes.LOGOUT_REQUEST, logoutRequest, api),
    takeLatest(AuthTypes.CLEAR_REQUEST, clearRequest, api),
    takeLatest(AuthTypes.FORGOT_PASSWORD_REQUEST, forgotPasswordRequest, api),
    takeLatest(AuthTypes.RESET_PASSWORD_REQUEST, resetPasswordRequest, api),
    takeLatest(AuthTypes.UPDATE_USER_INFORMATION_REQUEST, updateUserInformationRequest, api),
    takeLatest(AuthTypes.UPDATE_PASSWORD_REQUEST, updatePasswordRequest, api),
    takeLatest(AuthTypes.ACCEPT_INVITE_REQUEST, acceptInviteRequest, api),
    takeLatest(AuthTypes.SET_PASSWORD_REQUEST, setPasswordRequest, api),
    takeLatest(AuthTypes.GET_MY_COMPANY_REQUEST, getMyCompanyRequest, api),

    // App Sagas
    takeLatest(AppTypes.GET_BRANCHES_REQUEST, getBranchesRequest, api),
    takeLatest(AppTypes.GET_ROLES_REQUEST, getRolesRequest, api),
    takeLatest(AppTypes.GET_ALERTS_REQUEST, getAlertsRequest, api),
    takeLatest(AppTypes.TOGGLE_ALERT_REQUEST, toggleAlertRequest, api),
    takeLatest(AppTypes.GET_SERVER_TIME_REQUEST, getServerTimeRequest, api),
    takeLatest(AppTypes.SET_SERVER_TIME_REQUEST, setServerTimeRequest, api),

    // Shift Sagas
    takeLatest(ShiftTypes.GET_SHIFT_STATUS_REQUEST, getShiftStatusRequest, api),
    takeLatest(ShiftTypes.START_SHIFT_REQUEST, startShiftRequest, api),
    takeLatest(ShiftTypes.PAUSE_SHIFT_REQUEST, pauseShiftRequest, api),
    takeLatest(ShiftTypes.RESUME_SHIFT_REQUEST, resumeShiftRequest, api),
    takeLatest(ShiftTypes.TAKE_BREAK_REQUEST, takeBreakRequest, api),
    takeLatest(ShiftTypes.END_BREAK_REQUEST, endBreakRequest, api),
    takeLatest(ShiftTypes.END_SHIFT_REQUEST, endShiftRequest, api),
    takeLatest(ShiftTypes.TRACK_LOCATION_REQUEST, trackLocationRequest, api),
    takeLatest(ShiftTypes.GET_SHIFT_REPOSSESSIONS_OVERVIEW_REQUEST, getShiftRepossessionsOverviewRequest, api),
    takeLatest(ShiftTypes.GET_SHIFT_REPOSSESSIONS_GOALS_REQUEST, getShiftRepossessionsGoalsRequest, api),
    takeLatest(ShiftTypes.GET_SHIFT_REPOSSESSIONS_HIT_LIST_REQUEST, getShiftRepossessionsHitListRequest, api),
    takeLatest(ShiftTypes.GET_SPOTTED_VEHICLE_BY_VIN_REQUEST, getSpottedVehicleByVinRequest, api),
    takeLatest(ShiftTypes.SUBMIT_SPOTTED_VEHICLE_REQUEST, submitSpottedVehicleRequest, api),
    takeLatest(ShiftTypes.GET_CUSTOM_COMMISSIONS_REQUEST, getCustomCommissionsRequest, api),
    takeLatest(ShiftTypes.SUBMIT_CUSTOM_COMMISSION_REQUEST, submitCustomCommissionRequest, api),
    takeLatest(ShiftTypes.UPDATE_CUSTOM_COMMISSION_REQUEST, updateCustomCommissionRequest, api),
    takeLatest(ShiftTypes.CANCEL_CUSTOM_COMMISSION_REQUEST, cancelCustomCommissionRequest, api),
    takeLatest(ShiftTypes.GET_SHIFT_INFRACTIONS_REQUEST, getShiftInfractionsRequest, api),
    takeLatest(ShiftTypes.GET_SHIFT_PENDING_INFRACTIONS_REQUEST, getShiftPendingInfractionsRequest, api),
    takeLatest(ShiftTypes.SUBMIT_INFRACTION_ANSWER_REQUEST, submitInfractionAnswerRequest, api),

    // Stats Sagas
    takeLatest(StatsTypes.GET_MY_ACTIVITY_LEVEL_REQUEST, getMyActivityLevelRequest, api),
    takeLatest(StatsTypes.GET_MY_INFRACTIONS_REQUEST, getMyInfractionsRequest, api),
    takeLatest(StatsTypes.GET_INFRACTIONS_DETAILS_REQUEST, getInfractionsDetailsRequest, api),
    takeLatest(StatsTypes.GET_MY_SPOTTED_VEHICLES_REQUEST, getMySpottedVehiclesRequest, api),
    takeLatest(StatsTypes.GET_MY_REPOSSESSIONS_REQUEST, getMyRepossessionsRequest, api),
    takeLatest(StatsTypes.GET_MY_HOURS_WORKED_REQUEST, getMyHoursWorkedRequest, api),
    takeLatest(StatsTypes.GET_DAY_SHIFTS_REQUEST, getDayShiftsRequest, api),
    takeLatest(StatsTypes.GET_DAY_EXTRANEOUS_TIMES_REQUEST, getDayExtraneousTimesRequest, api),
    takeLatest(StatsTypes.GET_MY_COMMISSIONS_REQUEST, getMyCommissionsRequest, api),
    takeLatest(StatsTypes.GET_MY_MISSED_OPPORTUNITIES_REQUEST, getMyMissedOpportunitiesRequest, api),

    // Shift Admin Sagas
    // takeLatest(ShiftAdminTypes.GET_ACTIVE_SHIFTS_OVERVIEW_REQUEST, getActiveShiftsOverviewRequest, api),
    takeLatest(ShiftAdminTypes.GET_SHIFT_PREV_PERIOD_OVERVIEW_REQUEST, getShiftPrevPeriodOverviewRequest, api),
    takeLatest(ShiftAdminTypes.GET_SHIFT_COMMISSIONS_REQUEST, getShiftCommissionsRequest, api),
    // takeLatest(ShiftAdminTypes.GET_SHIFT_ALERTS_FEED_REQUEST, getShiftAlertsFeedRequest, api),
    // takeLatest(ShiftAdminTypes.GET_SHIFT_ALERTS_PAGINATION_FEED_REQUEST, getShiftAlertsPaginationFeedRequest, api),
    takeLatest(ShiftAdminTypes.SAVE_ALL_INFRACTIONS_REQUEST, saveAllInfractionsRequest, api),
    takeEvery(ShiftAdminTypes.SAVE_USER_INFRACTION_AS_RECORD_REQUEST, saveUserInfractionAsRecordRequest, api),
    takeEvery(ShiftAdminTypes.DELETE_USER_INFRACTION_REQUEST, deleteUserInfractionRequest, api),
    // takeLatest(ShiftAdminTypes.GET_SHIFT_CHECKLIST_FEED_REQUEST, getShiftChecklistFeedRequest, api),
    takeEvery(
      ShiftAdminTypes.MARK_FAILED_CHECKLIST_AS_COMPLETED_REQUEST,
      markFailedChecklistAsCompletedRequest,
      api,
    ),
    takeLatest(ShiftAdminTypes.GET_SHIFT_HOT_LIST_FEED_REQUEST, getShiftHotListFeedRequest, api),
    takeLatest(ShiftAdminTypes.UPDATE_HOT_LIST_VEHICLE_COMMENT_REQUEST, updateHotListVehicleCommentRequest, api),
    takeLatest(ShiftAdminTypes.DELETE_HOT_LIST_VEHICLE_COMMENT_REQUEST, deleteHotListVehicleCommentRequest, api),
    takeEvery(ShiftAdminTypes.ARCHIVE_MANUAL_HOT_LIST_REQUEST, archiveManualHotListRequest, api),

    // Stats Company Sagas
    takeLatest(StatsCompanyTypes.GET_ACTIVITY_LEVEL_REQUEST, getActivityLevelRequest, api),
    takeLatest(StatsCompanyTypes.GET_INFRACTIONS_REQUEST, getInfractionsRequest, api),
    takeLatest(StatsCompanyTypes.GET_USER_INFRACTIONS_REQUEST, getUserInfractionsRequest, api),
    takeLatest(StatsCompanyTypes.GET_TOTAL_MISSED_REPOSSESSIONS_REQUEST, getTotalMissedRepossessionsRequest, api),
    takeLatest(StatsCompanyTypes.GET_MISSED_REPOSSESSIONS_REQUEST, getMissedRepossessionsRequest, api),
    takeLatest(StatsCompanyTypes.GET_TOTAL_SPOTTED_VEHICLES_REQUEST, getTotalSpottedVehiclesRequest, api),
    takeLatest(StatsCompanyTypes.GET_SPOTTED_VEHICLES_REQUEST, getSpottedVehiclesRequest, api),
    takeLatest(StatsCompanyTypes.GET_TOTAL_REPOSSESSIONS_REQUEST, getTotalRepossessionsRequest, api),
    takeLatest(StatsCompanyTypes.GET_REPOSSESSIONS_REQUEST, getRepossessionsRequest, api),
    takeLatest(StatsCompanyTypes.GET_HOURS_WORKED_REQUEST, getHoursWorkedRequest, api),
    takeLatest(StatsCompanyTypes.GET_TOTAL_COMMISSIONS_REQUEST, getTotalCommissionsRequest, api),
    takeEvery(StatsCompanyTypes.GET_COMMISSIONS_REQUEST, getCommissionsRequest, api),

    // Company Sagas
    takeEvery(CompanyTypes.GET_COMPANY_DATA_REQUEST, getCompanyDataRequest, api),

    // Reports Sagas
    takeLatest(ReportsTypes.GET_MTDYTD_CLIENT_UNCATEGORIZED_REQUEST, getMTDYTDClientUncategorizedRequest, api),
    takeLatest(ReportsTypes.GET_YTD_CLIENT_STATS_REQUEST, getYTDClientStatsRequest, api),
    takeLatest(ReportsTypes.GET_MTD_PAST_YEARS_CLIENT_STATS_REQUEST, getMTDPastYearsClientStatsRequest, api),
    takeLatest(ReportsTypes.GET_DAILY_EMPLOYEES_SHIFT_REQUEST, getDailyEmployeesShiftRequest, api),
    takeLatest(ReportsTypes.GET_WEEKLY_EMPLOYEES_SHIFT_REQUEST, getWeeklyEmployeesShiftRequest, api),

    // Goals Sagas
    takeLatest(GoalsTypes.CREATE_CLIENT_GOAL_FOR_BONUS_REQUEST, createClientGoalForBonusRequest, api),
    takeLatest(GoalsTypes.UPDATE_CLIENT_GOAL_FOR_BONUS_REQUEST, updateClientGoalForBonusRequest, api),
    takeLatest(GoalsTypes.GET_MTDYTD_CLIENT_RR_GOALS_REQUEST, getMTDYTDClientRRGoalsRequest, api),

    // To-do List Sagas
    takeLatest(TodoListTypes.GET_TODO_CHECKLIST_REQUEST, getTodoChecklistRequest, api),
    takeLatest(TodoListTypes.SUBMIT_TODO_CHECKLIST_REQUEST, submitTodoChecklistRequest, api),
    takeLatest(TodoListTypes.UPDATE_CHECKLIST_COMMENT_REQUEST, updateChecklistCommentRequest, api),
    takeLatest(TodoListTypes.DELETE_CHECKLIST_COMMENT_REQUEST, deleteChecklistCommentRequest, api),
    takeLatest(TodoListTypes.GET_USERS_CUSTOM_COMMISSIONS_REQUEST, getUsersCustomCommissionsRequest, api),
    takeLatest(TodoListTypes.APPROVE_CUSTOM_COMMISSION_REQUEST, approveCustomCommissionRequest, api),
    takeLatest(TodoListTypes.DECLINE_CUSTOM_COMMISSION_REQUEST, declineCustomCommissionRequest, api),

    // Task Management Sagas
    takeLatest(TaskManagementTypes.GET_ASSIGNER_TASKS_REQUEST, getAssignerTasksRequest, api),
    takeLatest(TaskManagementTypes.CREATE_NEW_TASK_REQUEST, createNewTaskRequest, api),
    takeLatest(TaskManagementTypes.CLOSE_TASK_REQUEST, closeTaskRequest, api),
    takeLatest(TaskManagementTypes.READ_TASK_REQUEST, readTaskRequest, api),
    takeLatest(TaskManagementTypes.APPROVE_COMPLETED_REQUEST, approveCompletedRequest, api),
    takeLatest(TaskManagementTypes.REJECT_COMPLETED_REQUEST, rejectCompletedRequest, api),
    takeLatest(TaskManagementTypes.APPROVE_NEW_DEADLINE_REQUEST, approveNewDeadlineRequest, api),
    takeLatest(TaskManagementTypes.DECLINE_NEW_DEADLINE_REQUEST, declineNewDeadlineRequest, api),
    takeLatest(TaskManagementTypes.GET_RECEIVER_TASKS_REQUEST, getReceiverTasksRequest, api),
    takeLatest(TaskManagementTypes.PROPOSE_NEW_DEADLINE_REQUEST, proposeNewDeadlineRequest, api),
    takeLatest(TaskManagementTypes.CANCEL_NEW_DEADLINE_REQUEST, cancelNewDeadlineRequest, api),
    takeLatest(TaskManagementTypes.MARK_AS_COMPLETED_REQUEST, markAsCompletedRequest, api),
    takeLatest(TaskManagementTypes.ACKNOWLEDGE_UNCOMPLETED_REQUEST, acknowledgeUncompletedRequest, api),

    // HumanResources Sagas
    takeLatest(HumanResourcesTypes.GET_USERS_REQUEST, getUsersRequest, api),
    takeLatest(HumanResourcesTypes.GET_USERS_INFRACTIONS_REQUEST, getUsersInfractionsRequest, api),
    takeLatest(HumanResourcesTypes.GET_USERS_ACTIVITIES_REQUEST, getUsersActivitiesRequest, api),
    takeLatest(HumanResourcesTypes.GET_USERS_TASK_HISTORY_REQUEST, getUsersTaskHistoryRequest, api),
    takeLatest(HumanResourcesTypes.GET_USERS_COMMISSION_HISTORY_REQUEST, getUsersCommissionHistoryRequest, api),
    takeLatest(
      HumanResourcesTypes.GET_USERS_ACTIVITY_OVERVIEW_BY_ID_REQUEST,
      getUsersActivityOverviewByIdRequest,
      api,
    ),
    takeLatest(HumanResourcesTypes.GET_USERS_BY_BRANCH_REQUEST, getUsersByBranchRequest, api),
    takeLatest(HumanResourcesTypes.GET_USERS_ACTIVITY_PAGE_REQUEST, getUsersActivityPageRequest, api),

    takeLatest(HumanResourcesTypes.GET_OVERALL_USER_ACTIVITY_REQUEST, getOverallUserActivityRequest, api),

    takeLatest(HumanResourcesTypes.EMPLOYEE_FILE_LIST_REQUEST, employeeFileListRequest, api),
    takeLatest(HumanResourcesTypes.UPLOAD_EMP_FILE_REQUEST, uploadEmpFileRequest, api),

    // Checklist Sagas
    takeEvery(ChecklistTypes.GET_CHECKLIST_REQUEST, getChecklistRequest, api),
    takeEvery(ChecklistTypes.GET_CHECKLIST_BY_CATEGORY_REQUEST, getChecklistByCategoryRequest, api),
    takeLatest(ChecklistTypes.CREATE_CHECKLIST_ITEM_REQUEST, createChecklistItemRequest, api),
    takeLatest(ChecklistTypes.CREATE_CHECKLIST_ITEMS_MULTIPLE_REQUEST, createChecklistItemsMultipleRequest, api),
    takeLatest(ChecklistTypes.EDIT_CHECKLIST_ITEM_REQUEST, editChecklistItemRequest, api),
    takeLatest(ChecklistTypes.DELETE_CHECKLIST_ITEM_REQUEST, deleteChecklistItemRequest, api),
    takeLatest(ChecklistTypes.SUBMIT_USER_NT_CHECKLIST_REQUEST, submitUserNTChecklistRequest, api),
    takeLatest(ChecklistTypes.FETCH_USER_CHECKLIST_REQUEST, fetchUserChecklistRequest, api),
    takeLatest(ChecklistTypes.GET_USER_NT_CHECKLIST_REQUEST, getUserNTChecklistRequest, api),
    takeLatest(ChecklistTypes.SUBMIT_START_SHIFT_CHECKLIST_REQUEST, submitStartShiftChecklistRequest, api),
    takeLatest(ChecklistTypes.SUBMIT_END_SHIFT_CHECKLIST_REQUEST, submitEndShiftChecklistRequest, api),
    takeLatest(ChecklistTypes.GET_USER_SHIFT_CHECKLIST_REQUEST, getUserShiftChecklistRequest, api),

    // Shifts Sagas
    takeLatest(ShiftsTypes.GET_ALL_SHIFTS_REQUEST, getAllShiftsRequest, api),
    takeLatest(ShiftsTypes.GET_USER_SHIFTS_REQUEST, getUserShiftsRequest, api),
    takeLatest(ShiftsTypes.GET_SHIFT_REQUEST, getShiftRequest, api),
    takeLatest(ShiftsTypes.CREATE_SHIFT_REQUEST, createShiftRequest, api),
    takeLatest(ShiftsTypes.UPDATE_SHIFT_REQUEST, updateShiftRequest, api),
    takeLatest(ShiftsTypes.DELETE_SHIFT_REQUEST, deleteShiftRequest, api),

    // Shift Details Sagas
    takeLatest(ShiftDetailsTypes.GET_SHIFT_DETAILS_REQUEST, getShiftDetailsRequest, api),
    takeLatest(ShiftDetailsTypes.CREATE_TIME_CLOCK_REQUEST, createTimeClockRequest, api),
    takeLatest(ShiftDetailsTypes.UPDATE_TIME_CLOCK_REQUEST, updateTimeClockRequest, api),
    takeLatest(ShiftDetailsTypes.DELETE_TIME_CLOCK_REQUEST, deleteTimeClockRequest, api),
    takeLatest(ShiftDetailsTypes.CREATE_INDIVIDUAL_COMMISSIONS_REQUEST, createIndividualCommissionsRequest, api),
    takeLatest(ShiftDetailsTypes.UPDATE_INDIVIDUAL_COMMISSIONS_REQUEST, updateIndividualCommissionsRequest, api),
    takeLatest(ShiftDetailsTypes.DELETE_INDIVIDUAL_COMMISSIONS_REQUEST, deleteIndividualCommissionsRequest, api),
    takeLatest(ShiftDetailsTypes.CREATE_TEAM_COMMISSIONS_REQUEST, createTeamCommissionsRequest, api),
    takeLatest(ShiftDetailsTypes.UPDATE_TEAM_COMMISSIONS_REQUEST, updateTeamCommissionsRequest, api),
    takeLatest(ShiftDetailsTypes.DELETE_TEAM_COMMISSIONS_REQUEST, deleteTeamCommissionsRequest, api),
    takeLatest(ShiftDetailsTypes.CREATE_PER_VEHICLE_COMMISSIONS_REQUEST, createPerVehicleCommissionsRequest, api),
    takeLatest(ShiftDetailsTypes.UPDATE_PER_VEHICLE_COMMISSIONS_REQUEST, updatePerVehicleCommissionsRequest, api),
    takeLatest(ShiftDetailsTypes.DELETE_PER_VEHICLE_COMMISSIONS_REQUEST, deletePerVehicleCommissionsRequest, api),
  ]);
}
